/**
 * @generated SignedSource<<fb8cc675ee1ea8f9b6bfd2cfb693ab1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlightProvider = "KIWI" | "WAAVO";
import { FragmentRefs } from "relay-runtime";
export type KiwiSettings_settings$data = {
  readonly flightsProviderSettings: ReadonlyArray<{
    readonly apiKey: string | null;
    readonly baseUri: string | null;
    readonly flightsProvider: FlightProvider;
    readonly searchParams: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null;
    }> | null;
    readonly testMode: boolean | null;
  }> | null;
  readonly " $fragmentType": "KiwiSettings_settings";
};
export type KiwiSettings_settings$key = {
  readonly " $data"?: KiwiSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"KiwiSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KiwiSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightsProviderSettings",
      "kind": "LinkedField",
      "name": "flightsProviderSettings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flightsProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baseUri",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "testMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "apiKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KeyValuePair",
          "kind": "LinkedField",
          "name": "searchParams",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "889636a8f4b5cbf472d61081a5128fde";

export default node;
